// tslint:disable: variable-name
import { FavorecidoEnquadramento, TipoFavorecido } from '../../components/types';
import { BaseResourceModel } from '../../models/base-resource.model';
import { Cidade } from '../geo/cidade.model';
import { CodigoGps } from './codigo-gps.model';
import { FavorecidoBanco } from './favorecido-banco.model';
import { FavorecidoCnae } from './favorecido-cnae.model';
import { FavorecidoContato } from './favorecido-contato.model';
import { FavorecidoProduto } from './favorecido-produto.model';
import { FavorecidoTerceiroSetor } from './favorecido-terceiro-setor.model';
import { FavorecidoTipo } from './favorecido-tipo.model';

export class Favorecido extends BaseResourceModel {
    constructor(
        public id?: number,
        public tipo_favorecido?: TipoFavorecido,
        public nome?: string,
        public cpf_cnpj?: string,
        public nome_fantasia?: string,
        public inscricao_estadual?: string,
        public inscricao_municipal?: string,
        public inscricao_inss?: string,
        public cep?: string,
        public endereco?: string,
        public num_endereco?: string,
        public bairro?: string,
        public municipio?: string,
        public uf?: string,
        public complemento?: string,
        public ddd_fone?: string,
        public telefone?: string,
        public pis?: string,
        public email?: string,
        public tipo?: FavorecidoTipo,
        public url?: string,
        public enquadramento?: FavorecidoEnquadramento,
        public autarquia?: boolean,
        public autorizado?: boolean,
        public inativo?: boolean,
        public irrf?: boolean,
        public inss?: boolean,
        public servidor?: boolean,
        public simples_nacional?: boolean,
        public gasto_fixo?: boolean,
        public aux?: number,
        public terceiro_setor?: boolean,
        public cidade?: Cidade,
        public data_cadastro?: Date,
        public data_alteracao?: Date,
        public tipo_fornecedor?: string,
        public responsavel?: string,
        public produtos?: FavorecidoProduto[],
        public contatos?: FavorecidoContato[],
        public terceiro_setores?: FavorecidoTerceiroSetor[],
        public gps?: CodigoGps,
        public cnaes?: FavorecidoCnae[],
        public contas?: FavorecidoBanco[]
    ) {
        super();
    }
    static converteJson(json: any): Favorecido {
        return Object.assign(new Favorecido(), json);
    }
}
